import Repository from "./Repository";

export default {
  addPizzaMoney(payload) {
    console.log(payload);
    return Repository.post("/pizza-money/athletes", payload);
  },
};
